import { Component, Element, Host, h, Prop, Watch } from "@stencil/core";
import { debounce } from "../../../utils/debounce";

@Component({
    tag: "uic-header-menu-indicator",
    styleUrl: "header-menu-indicator.scss",
    shadow: false,
})
export class HeaderMenuIndicator {
    @Element() host: HTMLUicHeaderMenuIndicatorElement;

    /** The `header-menu-item` element that should be highlichted by the indicator */
    @Prop() target?: HTMLUicHeaderMenuItemElement | null = null;

    /** If set to `true` a vertical indicator is displayed on the left side  */
    @Prop() vertical: boolean = false;

    @Watch("target")
    setTarget() {
        this.update();
        if (this.target instanceof HTMLElement) {
            window.addEventListener("resize", this.handleWindowResize);
        } else {
            window.removeEventListener("resize", this.handleWindowResize);
        }
    }

    private update = () => {
        if (this.target instanceof HTMLElement && this.target.offsetWidth > 0) {
            if (this.vertical) {
                this.host.style.width = `4px`;
                this.host.style.height = `${this.target.offsetHeight}px`;
                this.host.style.transform = `translateY(${this.target.offsetTop}px)`;
            } else {
                this.host.style.width = `${this.target.offsetWidth}px`;
                this.host.style.height = `4px`;
                this.host.style.transform = `translateX(${this.target.offsetLeft}px)`;
            }
            this.host.style.display = "block";
        } else {
            this.reset();
        }
    };

    private reset = () => {
        this.host.style.width = "0px";
        this.host.style.display = "none";
        this.host.style.transform = "none";
    };

    private handleWindowResize = debounce(this.update, 20);

    componentWillLoad() {
        this.reset();
    }

    componentDidLoad() {
        this.setTarget();
    }

    disconnectedCallback() {
        window.removeEventListener("resize", this.handleWindowResize);
    }

    render() {
        return (
            <Host
                class={{
                    [`uic-header-menu-indicator`]: true,
                    [`uic-header-menu-indicator--horizontal`]:
                        this.vertical !== true,
                    [`uic-header-menu-indicator--vertical`]:
                        this.vertical === true,
                }}
            />
        );
    }
}
